const ajaxMorePost = ( $ ) => {
	const loadMoreButton = $( '.load-more-ajax' );
	const categoryFilter = $( '.selectric.category' );
	const statusFilter = $( '.selectric.status-filter' );
	const newsCategoryFilter = $( '.selectric.new-category' );
	const newsTagFilter = $( '.selectric.news-tag' );
	const areaOfFocusFilter = $( '.selectric.area-of-focus' );
	const typeOfOrganizationFilter = $( '.selectric.type-of-organization' );
	const searchFilter = $( 'button.icon-search' );
	const resetSearch = $( 'button.reset-search' );
	const searchFilterInput = $( '#search-filter' );
	const MIN_SEARCH_LENGTH = 3;
	const SEARCH_DEBOUNCE_DELAY = 400;
	let searchDebounceTimer = null;

	const getSearchInputValue = ( input ) =>
		input && input.length ? ( input.val() || '' ).trim() : '';

	const normalizeSearchValue = ( value ) => {
		const trimmed = ( value || '' ).trim();
		return trimmed.length >= MIN_SEARCH_LENGTH ? trimmed : '';
	};

	const getSearchValue = ( input ) =>
		normalizeSearchValue( getSearchInputValue( input ) );

	const getScope = ( element ) => {
		const $element = $( element );
		const $scope = $element.closest( '.cards-content, .section-news' );
		if ( $scope.length ) {
			return $scope;
		}

		const $section = $element.closest( 'section' );
		if ( $section.length ) {
			return $section;
		}

		return $element.parent();
	};

	const getScopeLoadMoreButtons = ( element ) => {
		const $scope = getScope( element );
		const $buttons = $scope.find( '.load-more-ajax' );
		return $buttons.length
			? $buttons
			: $( element ).closest( '.load-more-ajax' );
	};

	// Ajax request to load more posts and handle filters.
	if ( loadMoreButton.length ) {
		loadMoreButton.map( function ( i, el ) {
			hideLoadMoreButton(
				$( el ).data( 'max_page' ),
				$( el ).data( 'current_page' ),
				el
			);
		} );

		loadMoreButton.on( 'click', function ( e ) {
			e.preventDefault();

			const $button = $( this );
			const $scope = getScope( $button );
			const $categoryFilter = $scope.find( '.selectric.category' );
			const $statusFilter = $scope.find( '.selectric.status-filter' );
			const $newsCategoryFilter = $scope.find(
				'.selectric.new-category'
			);
			const $newsTagFilter = $scope.find( '.selectric.news-tag' );
			const $resourceLocationFilter = $scope.find(
				'.selectric.county-select'
			);
			let $searchFilterInput = $scope.find( '#search-filter' );
			if ( ! $searchFilterInput.length ) {
				$searchFilterInput = $scope.find( '.news-search-input' );
			}

			let taxName = $categoryFilter.data( 'tax_name' ) || '';
			let taxTerm = $categoryFilter.val() || '';

			let secondTaxName = $statusFilter.data( 'tax_name' ) || '';
			let secondTaxTerm = $statusFilter.val() || '';

			// Fallback to data attributes on the button if no filters are present
			if ( ! taxName ) {
				taxName = $button.data( 'tax_name' ) || '';
			}
			if ( ! taxTerm ) {
				taxTerm = $button.data( 'tax_term' ) || '';
			}
			if ( ! secondTaxName ) {
				secondTaxName = $button.data( 'second_tax_name' ) || '';
			}
			if ( ! secondTaxTerm ) {
				secondTaxTerm = $button.data( 'second_tax_term' ) || '';
			}

			if ( $newsCategoryFilter.length ) {
				taxName = $newsCategoryFilter.data( 'tax_name' ) || '';
				taxTerm = $newsCategoryFilter.val() || '';
			}

			if ( $newsTagFilter.length ) {
				secondTaxName = $newsTagFilter.data( 'tax_name' ) || '';
				secondTaxTerm = $newsTagFilter.val() || '';
			}

			let postNotIn = $button.data( 'post_no_in' ) || '';
			if ( taxName === 'category' && taxTerm && taxTerm !== 'all' ) {
				postNotIn = '';
			}

			const data = {
				action: themeVars.ajaxLoadMoreAction,
				nonce: themeVars.ajaxLoadMoreNonce,
				postType: $button.data( 'post_type' ) || '',
				postsPerPage: $button.data( 'posts_per_page' ) || 12,
				currentPage: Number( $button.data( 'current_page' ) ) + 1,
				appendWrapper: $button.data( 'append_wrapper' ) || '',
				context: $button.data( 'context' ) || '',
				colClass: $button.data( 'col_class' ) || '',
				imageWidth: $button.data( 'image_width' ) || '',
				imageHeight: $button.data( 'image_height' ) || '',
				taxName: taxName,
				taxTerm: taxTerm,
				secondTaxName: secondTaxName,
				secondTaxTerm: secondTaxTerm,
				postNotIn: postNotIn,
				county: $resourceLocationFilter.length
					? $resourceLocationFilter.val() || ''
					: '',
				search: getSearchValue( $searchFilterInput ),
			};

			sendAjaxRequest( data, $button );
		} );
	}

	// Ajax Category filter.
	if ( categoryFilter.length ) {
		categoryFilter.change( function ( e ) {
			const $scope = getScope( this );
			const $statusFilter = $scope.find( '.selectric.status-filter' );
			const $loadMoreButtons = getScopeLoadMoreButtons( this );
			const data = {
				action: themeVars.ajaxLoadMoreAction,
				nonce: themeVars.ajaxLoadMoreNonce,
				postType: $( this ).data( 'post_type' ) || '',
				postsPerPage: $( this ).data( 'posts_per_page' ) || 12,
				currentPage: Number( $( this ).data( 'current_page' ) ),
				appendWrapper: $( this ).data( 'append_wrapper' ) || '',
				taxName: $( this ).data( 'tax_name' ) || '',
				taxTerm: $( this ).val() || '',
				itemClass: $( this ).data( 'item_class' ) || '',
				secondTaxName: $statusFilter.data( 'tax_name' ) || '',
				secondTaxTerm: $statusFilter.val() || '',
			};

			sendAjaxRequest( data, $( this ) );
			$loadMoreButtons.data( 'current_page', 1 );
			updateUrlParams( {
				[ data.taxName ]: data.taxTerm,
				[ data.secondTaxName ]: data.secondTaxTerm,
			} );
		} );
	}

	// Ajax Status filter.
	if ( statusFilter.length ) {
		statusFilter.change( function ( e ) {
			const $scope = getScope( this );
			const $categoryFilter = $scope.find( '.selectric.category' );
			const data = {
				action: themeVars.ajaxLoadMoreAction,
				nonce: themeVars.ajaxLoadMoreNonce,
				postType: $( this ).data( 'post_type' ) || '',
				postsPerPage: $( this ).data( 'posts_per_page' ) || 12,
				currentPage: Number( $( this ).data( 'current_page' ) ),
				appendWrapper: $( this ).data( 'append_wrapper' ) || '',
				taxName: $( this ).data( 'tax_name' ) || '',
				taxTerm: $( this ).val() || '',
				itemClass: $( this ).data( 'item_class' ) || '',
				secondTaxName: $categoryFilter.data( 'tax_name' ) || '',
				secondTaxTerm: $categoryFilter.val() || '',
			};

			sendAjaxRequest( data, $( this ) );
			updateUrlParams( {
				[ data.taxName ]: data.taxTerm,
				[ data.secondTaxName ]: data.secondTaxTerm,
			} );
		} );
	}

	// Ajax News Category filter.
	if ( newsCategoryFilter.length ) {
		newsCategoryFilter.change( function ( e ) {
			const $scope = getScope( this );
			const $newsTagFilter = $scope.find( '.selectric.news-tag' );
			const $newsSearchInput = $scope.find( '.news-search-input' );
			const $loadMoreButtons = getScopeLoadMoreButtons( this );
			const selectedCategory = $( this ).val() || '';
			const postNotIn =
				selectedCategory && selectedCategory !== 'all'
					? ''
					: $( this ).data( 'post_no_in' ) || '';
			const data = {
				action: themeVars.ajaxLoadMoreAction,
				nonce: themeVars.ajaxLoadMoreNonce,
				postType: $( this ).data( 'post_type' ) || '',
				postsPerPage: $( this ).data( 'posts_per_page' ) || 9,
				currentPage: Number( $( this ).data( 'current_page' ) ),
				appendWrapper: $( this ).data( 'append_wrapper' ) || '',
				context: $( this ).data( 'context' ) || '',
				colClass: $( this ).data( 'col_class' ) || '',
				imageWidth: $( this ).data( 'image_width' ) || '',
				imageHeight: $( this ).data( 'image_height' ) || '',
				taxName: $( this ).data( 'tax_name' ) || '',
				taxTerm: selectedCategory,
				itemClass: $( this ).data( 'item_class' ) || '',
				secondTaxName: $newsTagFilter.data( 'tax_name' ) || '',
				secondTaxTerm: $newsTagFilter.val() || '',
				postNotIn: postNotIn,
				search: getSearchValue( $newsSearchInput ),
			};

			sendAjaxRequest( data, $( this ) );
			$loadMoreButtons.data( 'current_page', 1 );
			updateUrlParams( {
				[ data.taxName ]: data.taxTerm,
				[ data.secondTaxName ]: data.secondTaxTerm,
			} );
		} );
	}

	// Ajax News Tag filter.
	if ( newsTagFilter.length ) {
		newsTagFilter.change( function ( e ) {
			const $scope = getScope( this );
			const $newsCategoryFilter = $scope.find(
				'.selectric.new-category'
			);
			const $loadMoreButtons = getScopeLoadMoreButtons( this );
			const selectedCategory = $newsCategoryFilter.val() || '';
			const postNotIn =
				selectedCategory && selectedCategory !== 'all'
					? ''
					: $( this ).data( 'post_no_in' ) || '';
			const data = {
				action: themeVars.ajaxLoadMoreAction,
				nonce: themeVars.ajaxLoadMoreNonce,
				postType: $( this ).data( 'post_type' ) || '',
				postsPerPage: $( this ).data( 'posts_per_page' ) || 9,
				currentPage: Number( $( this ).data( 'current_page' ) ),
				appendWrapper: $( this ).data( 'append_wrapper' ) || '',
				context: $( this ).data( 'context' ) || '',
				colClass: $( this ).data( 'col_class' ) || '',
				imageWidth: $( this ).data( 'image_width' ) || '',
				imageHeight: $( this ).data( 'image_height' ) || '',
				taxName: $newsCategoryFilter.data( 'tax_name' ) || '',
				taxTerm: selectedCategory,
				itemClass: $( this ).data( 'item_class' ) || '',
				secondTaxName: $( this ).data( 'tax_name' ) || '',
				secondTaxTerm: $( this ).val() || '',
				postNotIn: postNotIn,
			};

			sendAjaxRequest( data, $( this ) );
			$loadMoreButtons.data( 'current_page', 1 );
			updateUrlParams( {
				[ data.taxName ]: data.taxTerm,
				[ data.secondTaxName ]: data.secondTaxTerm,
			} );
		} );
	}

	// Ajax Resource Location
	const resourceLocationFilter = $( '.selectric.county-select' );
	if ( resourceLocationFilter.length ) {
		resourceLocationFilter.change( function ( e ) {
			const $scope = getScope( this );
			const $areaOfFocusFilter = $scope.find(
				'.selectric.area-of-focus'
			);
			const $typeOfOrganizationFilter = $scope.find(
				'.selectric.type-of-organization'
			);
			const $searchFilterInput = $scope.find( '#search-filter' );
			const $loadMoreButtons = getScopeLoadMoreButtons( this );
			const data = {
				action: themeVars.ajaxLoadMoreAction,
				nonce: themeVars.ajaxLoadMoreNonce,
				postType: $( this ).data( 'post_type' ) || '',
				postsPerPage: $( this ).data( 'posts_per_page' ) || 9,
				currentPage: Number( $( this ).data( 'current_page' ) ),
				appendWrapper: $( this ).data( 'append_wrapper' ) || '',
				taxName: $areaOfFocusFilter.data( 'tax_name' ) || '',
				taxTerm: $areaOfFocusFilter.val() || '',
				itemClass: $( this ).data( 'item_class' ) || '',
				secondTaxName:
					$typeOfOrganizationFilter.data( 'tax_name' ) || '',
				secondTaxTerm: $typeOfOrganizationFilter.val() || '',
				county: $( this ).val() || '',
				search: getSearchValue( $searchFilterInput ),
			};

			sendAjaxRequest( data, $( this ) );
			$loadMoreButtons.data( 'current_page', 1 );
			updateUrlParams( {
				[ data.taxName ]: data.taxTerm,
				[ data.secondTaxName ]: data.secondTaxTerm,
				county: data.county,
				search: data.search,
			} );
		} );
	}

	// Ajax Area Of Focus.
	if ( areaOfFocusFilter.length ) {
		areaOfFocusFilter.change( function ( e ) {
			const $scope = getScope( this );
			const $typeOfOrganizationFilter = $scope.find(
				'.selectric.type-of-organization'
			);
			const $resourceLocationFilter = $scope.find(
				'.selectric.county-select'
			);
			const $searchFilterInput = $scope.find( '#search-filter' );
			const $loadMoreButtons = getScopeLoadMoreButtons( this );
			const data = {
				action: themeVars.ajaxLoadMoreAction,
				nonce: themeVars.ajaxLoadMoreNonce,
				postType: $( this ).data( 'post_type' ) || '',
				postsPerPage: $( this ).data( 'posts_per_page' ) || 9,
				currentPage: Number( $( this ).data( 'current_page' ) ),
				appendWrapper: $( this ).data( 'append_wrapper' ) || '',
				taxName: $( this ).data( 'tax_name' ) || '',
				taxTerm: $( this ).val() || '',
				itemClass: $( this ).data( 'item_class' ) || '',
				secondTaxName:
					$typeOfOrganizationFilter.data( 'tax_name' ) || '',
				secondTaxTerm: $typeOfOrganizationFilter.val() || '',
				county: $resourceLocationFilter.val() || '',
				search: getSearchValue( $searchFilterInput ),
			};

			sendAjaxRequest( data, $( this ) );
			$loadMoreButtons.data( 'current_page', 1 );
			updateUrlParams( {
				[ data.taxName ]: data.taxTerm,
				[ data.secondTaxName ]: data.secondTaxTerm,
				county: data.county,
				search: data.search,
			} );
		} );
	}

	// Ajax Type Of Organization.
	if ( typeOfOrganizationFilter.length ) {
		typeOfOrganizationFilter.change( function ( e ) {
			const $scope = getScope( this );
			const $areaOfFocusFilter = $scope.find(
				'.selectric.area-of-focus'
			);
			const $resourceLocationFilter = $scope.find(
				'.selectric.county-select'
			);
			const $searchFilterInput = $scope.find( '#search-filter' );
			const $loadMoreButtons = getScopeLoadMoreButtons( this );
			const data = {
				action: themeVars.ajaxLoadMoreAction,
				nonce: themeVars.ajaxLoadMoreNonce,
				postType: $( this ).data( 'post_type' ) || '',
				postsPerPage: $( this ).data( 'posts_per_page' ) || 9,
				currentPage: Number( $( this ).data( 'current_page' ) ),
				appendWrapper: $( this ).data( 'append_wrapper' ) || '',
				taxName: $( this ).data( 'tax_name' ) || '',
				taxTerm: $( this ).val() || '',
				itemClass: $( this ).data( 'item_class' ) || '',
				secondTaxName: $areaOfFocusFilter.data( 'tax_name' ) || '',
				secondTaxTerm: $areaOfFocusFilter.val() || '',
				county: $resourceLocationFilter.val() || '',
				search: getSearchValue( $searchFilterInput ),
			};

			sendAjaxRequest( data, $( this ) );
			$loadMoreButtons.data( 'current_page', 1 );
			updateUrlParams( {
				[ data.taxName ]: data.taxTerm,
				[ data.secondTaxName ]: data.secondTaxTerm,
				county: data.county,
				search: data.search,
			} );
		} );
	}

	// SVG icon markup.
	const searchIconSvg =
		'<svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.72917 9.83333C3.44236 9.83333 2.35342 9.38756 1.46233 8.496C0.57125 7.60444 0.125473 6.5155 0.125 5.22917C0.124528 3.94283 0.570306 2.85389 1.46233 1.96233C2.35436 1.07078 3.44331 0.625 4.72917 0.625C6.01503 0.625 7.10421 1.07078 7.99671 1.96233C8.88921 2.85389 9.33475 3.94283 9.33333 5.22917C9.33333 5.74861 9.2507 6.23854 9.08542 6.69896C8.92014 7.15937 8.69583 7.56667 8.4125 7.92083L12.3792 11.8875C12.509 12.0174 12.574 12.1826 12.574 12.3833C12.574 12.584 12.509 12.7493 12.3792 12.8792C12.2493 13.009 12.084 13.074 11.8833 13.074C11.6826 13.074 11.5174 13.009 11.3875 12.8792L7.42083 8.9125C7.06667 9.19583 6.65938 9.42014 6.19896 9.58542C5.73854 9.75069 5.24861 9.83333 4.72917 9.83333ZM4.72917 8.41667C5.61458 8.41667 6.36731 8.10689 6.98733 7.48733C7.60736 6.86778 7.91714 6.11506 7.91667 5.22917C7.9162 4.34328 7.60642 3.59079 6.98733 2.97171C6.36825 2.35263 5.61553 2.04261 4.72917 2.04167C3.84281 2.04072 3.09032 2.35074 2.47171 2.97171C1.8531 3.59268 1.54308 4.34517 1.54167 5.22917C1.54025 6.11317 1.85026 6.86589 2.47171 7.48733C3.09315 8.10878 3.84564 8.41856 4.72917 8.41667Z" fill="#3B3C43"/></svg>';
	const crossIconSvg =
		'<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#3B3C43"/></svg>';

	/**
	 * Switch a search button between search and cross icons.
	 *
	 * @param {jQuery} $btn   The button element.
	 * @param {string} mode   'search' | 'cross'
	 */
	const setSearchBtnIcon = function ( $btn, mode ) {
		if ( mode === 'cross' ) {
			$btn.html( crossIconSvg ).addClass( 'is-cross' );
		} else {
			$btn.html( searchIconSvg ).removeClass( 'is-cross' );
		}
	};

	// Ajax News Search (section-news block).
	const newsSearchInput = $( '.section-news .news-search-input' );
	const newsSearchBtn = $( '.section-news .news-search-btn' );

	if ( newsSearchInput.length ) {
		const triggerNewsSearch = function ( e ) {
			if ( e ) {
				e.preventDefault();
			}

			const rawValue = getSearchInputValue( newsSearchInput );
			const searchValue = normalizeSearchValue( rawValue );
			if ( rawValue.length > 0 && searchValue === '' ) {
				return;
			}

			// Toggle icon to cross when there is a search term.
			if ( searchValue.length > 0 ) {
				setSearchBtnIcon( newsSearchBtn, 'cross' );
			} else {
				setSearchBtnIcon( newsSearchBtn, 'search' );
			}

			const $scope = getScope( newsSearchInput );
			const $newsCategoryFilter = $scope.find(
				'.selectric.new-category'
			);
			const $loadMoreButtons = getScopeLoadMoreButtons( newsSearchInput );
			const selectedCategory = $newsCategoryFilter.length
				? $newsCategoryFilter.val() || ''
				: '';

			const data = {
				action: themeVars.ajaxLoadMoreAction,
				nonce: themeVars.ajaxLoadMoreNonce,
				postType: newsSearchInput.data( 'post_type' ) || 'post',
				postsPerPage: newsSearchInput.data( 'posts_per_page' ) || 12,
				currentPage: 1,
				appendWrapper: newsSearchInput.data( 'append_wrapper' ) || '',
				context: newsSearchInput.data( 'context' ) || '',
				colClass: newsSearchInput.data( 'col_class' ) || '',
				imageWidth: newsSearchInput.data( 'image_width' ) || '',
				imageHeight: newsSearchInput.data( 'image_height' ) || '',
				taxName:
					selectedCategory && selectedCategory !== 'all'
						? $newsCategoryFilter.data( 'tax_name' ) || 'category'
						: '',
				taxTerm:
					selectedCategory && selectedCategory !== 'all'
						? selectedCategory
						: '',
				itemClass: $newsCategoryFilter.data( 'item_class' ) || '',
				search: searchValue,
			};

			sendAjaxRequest( data, newsSearchInput );
			$loadMoreButtons.data( 'current_page', 1 );
		};

		newsSearchBtn.on( 'click', function ( e ) {
			// If button is in cross mode — clear input, reset icon, reload without search.
			if ( newsSearchBtn.hasClass( 'is-cross' ) ) {
				e.preventDefault();
				newsSearchInput.val( '' );
				setSearchBtnIcon( newsSearchBtn, 'search' );
				triggerNewsSearch();
				return;
			}
			triggerNewsSearch( e );
		} );

		newsSearchInput.on( 'keydown', function ( e ) {
			if ( e.key === 'Enter' ) {
				triggerNewsSearch( e );
			}
		} );
	}

	// Ajax Search Filter.
	if (
		( searchFilter.length || resetSearch.length ) &&
		searchFilterInput.length
	) {
		const toggleSearchIcons = function () {
			const hasText = getSearchInputValue( searchFilterInput ).length > 0;
			if ( hasText ) {
				$( resetSearch ).removeClass( 'hidden' );
			} else {
				$( resetSearch ).addClass( 'hidden' );
			}
		};

		const triggerSearch = function ( e ) {
			if ( e ) {
				e.preventDefault();
			}
			if ( searchDebounceTimer ) {
				window.clearTimeout( searchDebounceTimer );
			}

			const rawSearchValue = getSearchInputValue( searchFilterInput );
			const searchValue = normalizeSearchValue( rawSearchValue );
			if ( rawSearchValue.length > 0 && searchValue === '' ) {
				toggleSearchIcons();
				return;
			}

			const $scope = getScope( searchFilterInput );
			const $areaOfFocusFilter = $scope.find(
				'.selectric.area-of-focus'
			);
			const $typeOfOrganizationFilter = $scope.find(
				'.selectric.type-of-organization'
			);
			const $resourceLocationFilter = $scope.find(
				'.selectric.county-select'
			);
			const $loadMoreButtons =
				getScopeLoadMoreButtons( searchFilterInput );
			const data = {
				action: themeVars.ajaxLoadMoreAction,
				nonce: themeVars.ajaxLoadMoreNonce,
				postType: $( searchFilterInput ).data( 'post_type' ) || '',
				postsPerPage:
					$( searchFilterInput ).data( 'posts_per_page' ) || 9,
				currentPage:
					Number( $( searchFilterInput ).data( 'current_page' ) ) ||
					1,
				appendWrapper:
					$( searchFilterInput ).data( 'append_wrapper' ) || '',
				itemClass: $( searchFilterInput ).data( 'item_class' ) || '',
				taxName: $areaOfFocusFilter.data( 'tax_name' ) || '',
				taxTerm: $areaOfFocusFilter.val() || '',
				secondTaxName:
					$typeOfOrganizationFilter.data( 'tax_name' ) || '',
				secondTaxTerm: $typeOfOrganizationFilter.val() || '',
				county: $resourceLocationFilter.val() || '',
				search: searchValue,
			};

			sendAjaxRequest( data, $( searchFilter ) );
			$loadMoreButtons.data( 'current_page', 1 );
			updateUrlParams( {
				[ data.taxName ]: data.taxTerm,
				[ data.secondTaxName ]: data.secondTaxTerm,
				county: data.county,
				search: data.search,
			} );

			// Update icons according to the current input value
			toggleSearchIcons();
		};

		const queueSearch = function () {
			const rawSearchValue = getSearchInputValue( searchFilterInput );
			const searchValue = normalizeSearchValue( rawSearchValue );
			if ( rawSearchValue.length > 0 && searchValue === '' ) {
				toggleSearchIcons();
				return;
			}
			if ( searchDebounceTimer ) {
				window.clearTimeout( searchDebounceTimer );
			}
			searchDebounceTimer = window.setTimeout( function () {
				triggerSearch();
			}, SEARCH_DEBOUNCE_DELAY );
		};

		// Initial icon state based on current input value (including URL prefill)
		toggleSearchIcons();

		searchFilter.on( 'click', triggerSearch );
		searchFilterInput.on( 'keydown', function ( e ) {
			if ( e.key === 'Enter' ) {
				triggerSearch( e );
			}
		} );

		// Toggle icons live as user types and debounce search
		searchFilterInput.on( 'input', function () {
			toggleSearchIcons();
			queueSearch();
		} );

		// Reset button clears the field and triggers a new AJAX request
		resetSearch.on( 'click', function ( e ) {
			e.preventDefault();
			$( searchFilterInput ).val( '' );
			toggleSearchIcons();
			triggerSearch( e );
		} );
	}

	/**
	 * Hide the load more button if the current page is the last page.
	 * @param maxPaged
	 * @param currentPage
	 * @param element
	 */
	function hideLoadMoreButton( maxPaged, currentPage, element ) {
		const max = parseInt( maxPaged, 10 );
		const current = parseInt( currentPage, 10 );
		const $element = $( element );

		if ( current >= max ) {
			$element.each( function () {
				this.style.setProperty( 'display', 'none', 'important' );
			} );
		} else {
			$element.each( function () {
				this.style.removeProperty( 'display' );
			} );
			$element.show();
		}
	}

	/**
	 * Update URL parameters without page reload
	 *
	 * @param {Object} params Object containing parameters to add to URL
	 */
	function updateUrlParams( params ) {
		if ( ! params || typeof params !== 'object' ) {
			return;
		}

		const url = new URL( window.location.href );

		url.search = '';
		Object.keys( params ).forEach( ( key ) => {
			if (
				params[ key ] !== '' &&
				params[ key ] !== null &&
				params[ key ] !== undefined
			) {
				url.searchParams.set( key, params[ key ] );
			}
		} );
		window.history.pushState( {}, '', url );
	}

	/**
	 * Send an AJAX request to load more posts.
	 *
	 * @param {Object} data    Ajax request data object containing
	 * @param {Object} element jQuery element that triggered the request
	 */
	function sendAjaxRequest( data, element ) {
		if ( data.length === 0 ) {
			console.error( 'No data to send in AJAX request.' );
			return;
		}

		const $scope = getScope( element );
		const $loadMoreButtons = getScopeLoadMoreButtons( element );

		$loadMoreButtons.prop( 'disabled', true );

		const $appendWrapper = data.appendWrapper
			? $scope.find( data.appendWrapper )
			: $();
		const $targetWrapper = $appendWrapper.length
			? $appendWrapper
			: $( data.appendWrapper );

		$.ajax( {
			url: themeVars.ajaxurl,
			type: 'POST',
			data,
			success( response ) {
				$loadMoreButtons.prop( 'disabled', false );

				if ( response.success ) {
					if ( data.itemClass ) {
						$targetWrapper.find( data.itemClass ).remove();
					}

					$scope.find( '.error-notification' ).remove();
					$targetWrapper.append( response.data.html );
					if ( $loadMoreButtons.length ) {
						$loadMoreButtons.data(
							'current_page',
							data.currentPage
						);
						$loadMoreButtons.data(
							'max_page',
							response.data.maxPage
						);
					} else {
						$( element ).data( 'current_page', data.currentPage );
						$( element ).data( 'max_page', response.data.maxPage );
					}

					hideLoadMoreButton(
						response.data.maxPage,
						data.currentPage,
						$loadMoreButtons.length
							? $loadMoreButtons
							: $( element )
					);
				} else {
					$scope.find( '.error-notification' ).remove();
					if ( data.itemClass ) {
						$targetWrapper.find( data.itemClass ).remove();
					}
					$targetWrapper.append( response.data.html );
					hideLoadMoreButton(
						1,
						1,
						$loadMoreButtons.length
							? $loadMoreButtons
							: $( element )
					);
				}
			},
			error( jqXHR, textStatus, errorThrown ) {
				$loadMoreButtons.prop( 'disabled', false );
				console.error( 'AJAX Error:', textStatus, errorThrown );
			},
		} );
	}
};

export default ( ( $ ) => $( ajaxMorePost ) )( jQuery );
